"use strict";

var cov_a5ji8ja3l = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\usfm\\Usfm.context.js";
  var hash = "5a34011cde8ab0c203afd26e7a82c68ed551e064";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\usfm\\Usfm.context.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 27
        },
        end: {
          line: 6,
          column: 48
        }
      },
      "1": {
        start: {
          line: 12,
          column: 15
        },
        end: {
          line: 12,
          column: 32
        }
      },
      "2": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "3": {
        start: {
          line: 21,
          column: 0
        },
        end: {
          line: 24,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "UsfmContextProvider",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 35
          }
        },
        loc: {
          start: {
            line: 11,
            column: 3
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "5a34011cde8ab0c203afd26e7a82c68ed551e064"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsfmContextProvider = UsfmContextProvider;
exports.UsfmContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("..");

var UsfmContext = (cov_a5ji8ja3l.s[0]++, _react.default.createContext());
exports.UsfmContext = UsfmContext;

function UsfmContextProvider(_ref) {
  var usfm = _ref.usfm,
      children = _ref.children;
  cov_a5ji8ja3l.f[0]++;
  var json = (cov_a5ji8ja3l.s[1]++, (0, _.useUsfm)({
    usfm: usfm
  }));
  cov_a5ji8ja3l.s[2]++;
  return _react.default.createElement(UsfmContext.Provider, {
    value: json
  }, children);
}

;
cov_a5ji8ja3l.s[3]++;
UsfmContextProvider.propTypes = {
  /** The usfm string to parse */
  usfm: _propTypes.default.string.isRequired
};